import React, {useState} from 'react';
import {Modal, Button, Icon, Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {useDispatch, useSelector} from 'react-redux';

const {
  fecthComboDealersList,
  cleanComboDealersList,
} = Actions;

const ComboDealersModal = ({code}) => {
  const [modalOpened, setModalOpened] = useState(false);
  const comboDealersList = useSelector((state) => state.comboDealers.list);
  const dispatch = useDispatch();
  
  const openComboDealersModal = (e) => {
    e.preventDefault();
    dispatch(fecthComboDealersList(code));
    setModalOpened(true);
  };

  const closeComboAccesorioesModal = (e) => {
    e.preventDefault();
    dispatch(cleanComboDealersList());
    setModalOpened(false);
  };

  return (
    <Modal
      trigger={<Icon className='storefront' size='big' color={'red'} link
        onClick={(e) => openComboDealersModal(e)} />
      }
      open={modalOpened}
      onClose={(e) => openComboDealersModal(e)}
      size='large'
    >
      <Modal.Header>Concesionarios asociados</Modal.Header>
      <Modal.Content>
        <div className="m-2">
          <Table striped className='dashboard-table'>
            <Table.Header className='orders-table-header'>
              <Table.Row>
                <Table.HeaderCell>RUC</Table.HeaderCell>
                <Table.HeaderCell>Nombre</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {comboDealersList ?
                comboDealersList.map((item, index) => {
                  return <Table.Row key={index}>
                    <Table.Cell>{item.identification}</Table.Cell>
                    <Table.Cell>{item.name}</Table.Cell>
                  </Table.Row>;
                }) : ''
              }
            </Table.Body>
          </Table>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button color='black' onClick={(e) => closeComboAccesorioesModal(e)}>
              Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ComboDealersModal;
